module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flashlight-d2732a9d13117aefe7e0c6d8b4718405.svg";